import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';

import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { FEEDBACK_SLICE_NAME, FeedbackSliceState } from './feedback.slice.types.ts';

export const FEEDBACK_SLICE_INITIAL_STATE: FeedbackSliceState = {
  isFeedbackDrawerOpen: false,
};

const persistKeys: (keyof FeedbackSliceState)[] = [];

const persistConfig = {
  key: FEEDBACK_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: persistKeys,
} as PersistConfig<FeedbackSliceState>;

const feedbackSlice = createSlice({
  name: FEEDBACK_SLICE_NAME,
  initialState: FEEDBACK_SLICE_INITIAL_STATE,
  reducers: {
    resetFeedbackSlice: () => FEEDBACK_SLICE_INITIAL_STATE,
    setFeedbackIsDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isFeedbackDrawerOpen = action.payload;
    },
  },
});

export const { setFeedbackIsDrawerOpen, resetFeedbackSlice } = feedbackSlice.actions;

export const FeedbackSlice = persistReducer(persistConfig, feedbackSlice.reducer);
